export default class PlaceGrid extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-place-grid', PlaceGrid);
